import React from 'react';
import { Link, useLocation, matchPath } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

export interface NavigationLinkProps {
  to: string;
  textContent: string;
  icon?: (props: React.ComponentProps<'svg'>) => JSX.Element;
  linkClassName?: string;
}

const NavigationLink: React.FC<NavigationLinkProps> = ({
  to,
  textContent,
  icon: IconComponent,
  linkClassName,
}) => {
  const { pathname } = useLocation();
  const isActiveLink = !!matchPath(`${to}/*`, pathname);

  const linkClassNames = twMerge(
    'flex',
    'items-center',
    'h-full',
    'py-3',
    'px-4',
    'border-b-[3px]',
    'mt-[3px]',
    'border-transparent',
    `${
      isActiveLink
        ? 'text-kira-blue-800 border-kira-blue-800'
        : 'text-kira-slate-700'
    }`,
    linkClassName
  );

  const iconClassNames = twMerge('w-6', 'h-6', 'mr-2');
  const textClassNames = twMerge(
    'prose-body-md-med',
    `${isActiveLink ? 'font-medium' : 'font-normal'}`
  );

  return (
    <Link
      to={to}
      className={linkClassNames}
      id={`${textContent}-nav-link`}
      data-testid={`${textContent}`}
    >
      {IconComponent && <IconComponent className={iconClassNames} />}
      <span className={textClassNames}>{textContent}</span>
    </Link>
  );
};

export default NavigationLink;
